import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTable from "primevue/datatable";
import Column from "primevue/column";

import moment from "moment";

import {inject, onMounted, ref} from "vue";
import {AxiosStatic} from "axios";

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ListRateTable',
  setup(__props, { expose }) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const rates = ref<any[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)

// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define methods
function formatTimestamp(input: string): string {
  return moment(input).format('DD.MM.YYYY')
}

function loadData(filterData: any = {}) {
  loading.value = true
  axios?.get("/rate/list")
      .then((response) => {
        if (response.status === 200) {
          rates.value = response.data
        }
        totalRecords.value = response.data.length
        loading.value = false
      }).catch(error => {
    console.error('Can not load rates', error)
    loading.value = false
  })
}

function reload() {
  loadData()
}

expose({reload})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    page: pageIndex.value+1,
    ref_key: "dt",
    ref: dt,
    dataKey: "id",
    value: rates.value,
    paginator: true,
    rows: pageSize.value,
    totalRecords: totalRecords.value,
    filterDisplay: "row",
    loading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "id",
        header: "ID"
      }),
      _createVNode(_unref(Column), {
        field: "companyName",
        header: "COMPANY NAME",
        filterMatchMode: "startsWith",
        ref: "companyName"
      }, null, 512),
      _createVNode(_unref(Column), {
        field: "validSince",
        header: "Platne od"
      }, {
        body: _withCtx(({data}) => [
          _createTextVNode(_toDisplayString(formatTimestamp(data.validSince)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "rate",
        header: "Sazba [Kc/MD]"
      })
    ]),
    _: 1
  }, 8, ["page", "value", "rows", "totalRecords", "loading"]))
}
}

})